import styled from '@emotion/styled'
import { calcRem, colors } from '../../__styling'
import { tokens } from '@news-mono/design-tokens'
import { CardText } from '../../cards/CardText/CardText'
import { CardMedia } from '../../cards/CardMedia/CardMedia'

export interface StyledInlineContentCardProps {
    isSideBarCmp?: boolean
}

export const StyledInlineContentCard = styled(
    'div',
)<StyledInlineContentCardProps>(({ theme, isSideBarCmp }) => [
    {
        display: 'grid',
        gridTemplateColumns: '3fr 2fr',
    },
    isSideBarCmp
        ? {
              marginBottom: calcRem(20),
          }
        : {
              padding: calcRem(10),
              border: `${calcRem(1)} solid ${
                  tokens.sevennews.colors.palette.articlesV2.cardsBorder
              }`,
          },
])

export const StyledTextContainer = styled('div')(() => [
    {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        paddingRight: calcRem(15),
    },
])

export const StyledCardImageContainer = styled(
    'div',
)<StyledInlineContentCardProps>(({ theme, isSideBarCmp }) => [
    isSideBarCmp
        ? {
              position: 'relative',
              '&::after': {
                  content: `''`,
                  position: 'absolute',
                  left: 0,
                  width: '30%',
                  paddingTop: calcRem(5),
                  borderBottom: `${calcRem(1)} solid ${
                      tokens.sevennews.colors.palette.articlesV2.cardsBorder
                  }`,
              },
          }
        : {},
])

export const StyledText = styled(CardText)(({ theme }) => [
    {
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: 4,
        overflow: 'hidden',
        maxHeight: calcRem(66),
    },
])

export const StyledTimeToRead = styled('p')(() => [
    {
        color: colors.sevennews.nero,
        fontSize: calcRem(12),
        opacity: 0.3,
    },
])

export const StyledCardImage = styled(CardMedia)(({ theme }) => [{}])
